import React from 'react';
import { Typography, IconButton } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import PropTypes from 'prop-types';

const SkillsAwardSection = ({
  sectionClass,
  SKILL_CERT_PROFILE,
  certifications,
  certificationsExpanded,
  toggleCertifications,
}) => {
  return (
    <Typography className={sectionClass}>
      <span className="skills-award-title">
        {SKILL_CERT_PROFILE.CERTIFICATIONS}
      </span>
      <span className="skills-award-count-text">
        {SKILL_CERT_PROFILE.TOTAL}:{' '}
        <span>{certifications?.totalMapsCount || 0}</span> |{' '}
        {SKILL_CERT_PROFILE.PROFESSIONAL}:{' '}
        <span>{certifications?.professionalCertCount || 0}</span>
        <IconButton onClick={toggleCertifications}>
          {certificationsExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </span>
    </Typography>
  );
};
SkillsAwardSection.propTypes = {
  sectionClass: PropTypes.string.isRequired,
  SKILL_CERT_PROFILE: PropTypes.isRequired,
  certifications: PropTypes.isRequired,
  toggleCertifications: PropTypes.func.isRequired,
  certificationsExpanded: PropTypes.bool.isRequired,
};

export default SkillsAwardSection;
